import { Col, Row } from '@zg-rentals/zrs-comet';
import AddMessageSkeleton from '../AddMessage/skeleton';
import Bone from '../Bone';
import { StyledFlexThreadContainer, StyledMessageListSkeletonContainer } from './StyledComponents';

export const MessageListContentsSkeleton = (): JSX.Element => {
  return (
    <>
      {[...Array(8)].map((_, idx) => {
        return (
          <div key={idx}>
            <Row hidden={[]} paddingY="xs">
              <Col xs={6}>
                <Bone dark={true} type="chatBubble" />
              </Col>
            </Row>

            <Row hidden={[]} paddingY="xs">
              <Col xs={7}>
                <Bone dark={true} type="chatBubble" />
              </Col>
            </Row>

            <Row hidden={[]} paddingY="xs">
              <Col>
                <Bone floatRight={true} dark={true} type="chatBubble" />
              </Col>
            </Row>

            <Row hidden={[]} paddingY="xs">
              <Col xs={9}>
                <Bone dark={true} type="chatBubble" />
              </Col>
            </Row>
          </div>
        );
      })}
    </>
  );
};

export const MessageListSkeleton = (): JSX.Element => {
  return (
    <StyledMessageListSkeletonContainer>
      <StyledFlexThreadContainer>
        <MessageListContentsSkeleton />
      </StyledFlexThreadContainer>
      <AddMessageSkeleton />
    </StyledMessageListSkeletonContainer>
  );
};
